export default [
    "PFTT",
    "PFFTT",
    "PFPTTF",
    "PFTTF"
];
